module.exports = __webpack_public_path__ + "static/sp_checkout_4-ee8527e829377c774abc1d76d9eb3f64.jpg";